/*
 * @Author: zhengyi yi.zheng@yunzhihulian.cn
 * @Date: 2023-05-19 18:23:09
 * @LastEditors: zhengyi yi.zheng@yunzhihulian.cn
 * @LastEditTime: 2023-09-22 13:54:13
 * @FilePath: \whds-new-front-web\src\requests\emplyee.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from '@/utils/http';
import httpApi from '@/apis/httpApi';

// 获取员工管理列表
export const getEmplyeeTableList = ({ page, pageSize, search }) => {
  return http.usualPost({
    url: httpApi.emplyee.getTableList,
    data: {
      page,
      pageSize,
      search,
    },
  });
};
// 删除
export const _del = ({ passportName, smsCode }) => {
  return http.post({
    url: httpApi.emplyee.del,
    data: {
      passportName,
      smsCode,
    },
  });
};
// 状态
export const _status = ({ passportName, freezeState, smsCode }) => {
  return http.post({
    url: httpApi.emplyee.status,
    data: {
      passportName,
      freezeState,
      smsCode,
    },
  });
};
// 修改备注
export const _remark = ({ passportName, remark }) => {
  return http.post({
    url: httpApi.emplyee.mark,
    data: {
      passportName,
      remark,
    },
  });
};
// 注册子账号
export const registeredSubAccount = (data) => {
  return http.post({
    url: httpApi.emplyee.registerAdd,
    json: data
  });
};
// 修改
export const Edit = (data) => {
  return http.post({
    url: httpApi.emplyee.edit,
    json: data
  });
};

// 查询网吧分组列表
export const _searchGroupName = ({ groupName }) => {
  return http.usualPost({
    url: httpApi.emplyee.getSearchGroupNameList,
    data: {
      groupName,
    },
  });
};
// 查询网吧列表列表
export const _searchBarName = ({ barName }) => {
  return http.usualPost({
    url: httpApi.emplyee.getSearchBarNameList,
    data: {
      barName,
    },
  });
};
// 获取短信
export const getsmscode = () => {
  return http.post({
    url: httpApi.emplyee.getsmscode,
  });
};
export const switchSafeCenter = (data) => {
  return http.post({
    url: httpApi.emplyee.switchSafeCenter,
    data: data,
  });
};
export const switchDllFlag = (data) => {
  return http.post({
    url: httpApi.emplyee.switchDllFlag,
    data: data,
  });
};
